import { render, staticRenderFns } from "./QaCategory.vue?vue&type=template&id=4c61af8e&scoped=true&"
import script from "./QaCategory.vue?vue&type=script&lang=js&"
export * from "./QaCategory.vue?vue&type=script&lang=js&"
import style0 from "./QaCategory.vue?vue&type=style&index=0&id=4c61af8e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c61af8e",
  null
  
)

export default component.exports